import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { CommunityOutreachFormValues } from '../components/CommunityOutreachForm/CommunityOutreachForm.types';
import { submitInquiryForm } from '../services/inquiry-form.service';
import { COMMUNITY_OUTREACH_INQUIRY_FORM } from '../constants/api';

export interface CommunityOutreachFormValuesContext {
  prevoiusGoals: CommunityOutreachFormValues;
}

export type CommunityOutreachFormValuesVariables = CommunityOutreachFormValues;

function useMutationFormInquiryForm(
  onSuccess: (
    data: any,
    variables: CommunityOutreachFormValues,
    context: CommunityOutreachFormValuesContext | undefined,
  ) => {},
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async (formValues: CommunityOutreachFormValues): Promise<any> => {
    return await submitInquiryForm(formValues);
  };

  const onMutateFn = async (): Promise<any> => {
    await queryClient.cancelQueries({ queryKey: [COMMUNITY_OUTREACH_INQUIRY_FORM] });

    return queryClient.getQueryData([COMMUNITY_OUTREACH_INQUIRY_FORM]) as CommunityOutreachFormValues;
  };

  const onErrorFn = (err: unknown, _id: string, context: CommunityOutreachFormValuesContext | undefined): void => {
    if (context?.prevoiusGoals !== undefined) {
      queryClient.setQueryData([COMMUNITY_OUTREACH_INQUIRY_FORM], context.prevoiusGoals);
    }
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {
    setTimeout(() => {
      void queryClient.invalidateQueries([COMMUNITY_OUTREACH_INQUIRY_FORM]);
    }, 2000);
  };

  return useMutation<string, unknown, any, any>([COMMUNITY_OUTREACH_INQUIRY_FORM], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess,
  });
}

export default useMutationFormInquiryForm;
